module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.c2e7a6d.woff2";